module.exports = require("./dist/react-switch.dev.js");
